import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/App/Layout";
import MainAbout from "../../RaymonComponents/about/MainAbout";
import PageBanner from "../../RaymonComponents/Commn/PageBanner";
import Footer from "../../RaymonComponents/Footer2";
import NavbarTwo from "../../RaymonComponents/Navbar";
import { Router } from "@reach/router";
const AboutUs = () => {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          href="https://pro.fontawesome.com/releases/v5.10.0/css/all.css"
          integrity="sha384-AYmEC3Yw5cVb3ZcuHtOA93w35dYTsvhLPVnYs9eStHfGJvOvKxVfELGroGkvsg+p"
          crossorigin="anonymous"
        />
      </Helmet>
      <Layout>
        <NavbarTwo />
        <PageBanner
          pageTitle="درباره ما"
          homePageText="درباره ما"
          homePageUrl="/"
          activePageText="خانه"
        />

        <MainAbout />
        <Footer />
      </Layout>
    </>
  );
};
export default AboutUs;
